import { render, staticRenderFns } from "./Barcodes.vue?vue&type=template&id=3d297c1c&"
import script from "./Barcodes.vue?vue&type=script&lang=js&"
export * from "./Barcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports